import { Link, useNavigate, useSearchParams } from "react-router-dom";
import classes from "./Feed.module.css";
import { useEffect, useState } from "react";
import {
  advancedClientSearch,
  clientAddShortlistTalent,
  clientGetShortlistedTalents,
  clientRemoveShortlistTalent,
  clientSearchTalents,
  getAllClientJobs,
} from "../../../services/clientCalls";
import {
  errorHandler,
  isPlanLimitError,
  planLimitHandler,
  toastSuccess,
} from "../../../utils";
import FullScreenLoader from "../../Loaders/FullScreen/loader";
import { currencyFormat } from "../../../utils/functions";
import Pagination from "rc-pagination";
import SearchModal from "../../SearchModalClient/searchModal";
import Matches from "../../../assets/svgs/matches.svg";
import Loop2 from "../../../assets/loader/loop2.svg";
import TalentRow from "../../../pages/ClientDashboard/Feed/components/TalentRow";
import {
  IconBookmark,
  IconChevronLeft,
  IconChevronRight,
  IconSearchOff,
} from "@tabler/icons-react";
import EmptyState from "../../../pages/ClientDashboard/Feed/components/EmptyState";

const ClientFeed = ({
  isSearchModalOpen,
  setIsSearchModalOpen,
  isShortlist,
  filters,
  setFilters,
  matchCancelled,
  refine,
}) => {
  const [totalItems, setTotalItems] = useState(null);
  const [totalItemsAll, setTotalItemsAll] = useState(null);
  const [allJobsArr, setAllJobsArr] = useState([]);
  const [allShortlistArr, setAllShortlistArr] = useState([]);
  const [allShortlistData, setAllShortlistData] = useState(null);
  const [allAllJobsData, setAllJobsData] = useState(null);
  const [load, setLoad] = useState(false);
  const [fullLoad, setFullLoad] = useState(false);
  const [shortlistLoading, setShortlistLoading] = useState(false);
  const [page, setPage] = useState(1);
  const navigate = useNavigate();
  const [starredIds, setStarredIds] = useState({});
  const [searchParams] = useSearchParams();
  const searchQuery = searchParams.get("search");
  

  // const [filters, setFilters] = useState({
  //   role: "",
  //   skills: "",
  //   location: "",
  //   paymentMin: "",
  //   paymentMax: "",
  //   jobTypes: "",
  //   workModes: "",
  //   // advancedFilters: true,
  // });
  const [dateQuery, setDateQuery] = useState("");
  const [dataToSubmit, setDataToSubmit] = useState({});

  const fetchAllJobs = async (page, searchFilters = {}) => {
    setLoad(true);
    try {
      const payload = { ...filters, ...searchFilters };
      if (!filters.completedPsychometrics) {
        delete payload.completedPsychometrics;
      }
      const res = await clientSearchTalents(page, payload);
      // console.log(page, "page in fetchAllJobs");
      if (page !== res?.data?.count) {
        setAllJobsData(res?.data);
        setTotalItemsAll(res?.data?.totalItems);
      }
      if (res?.data?.data) {
        setAllJobsArr(res?.data?.data);
      }
      setLoad(false);
      setFullLoad(false);
    } catch (error) {
      setLoad(false);
      setFullLoad(false);
      error?.response?.data
        ? errorHandler(error?.response?.data?.errors, "Error")
        : errorHandler(
            "Network error: Something went wrong, Please check your internet connection and try again.",
            "Error",
          );
    }
  };
  const fetchAllShortlisted = async (page) => {
    setLoad(true);
    try {
      const res = await clientGetShortlistedTalents(page);
      if (page !== res?.data) {
        setAllShortlistData(res?.data?.data);
      }
      if (res?.data?.data?.records) {
        setAllShortlistArr(res?.data?.data?.records);
      }
      setLoad(false);
      setFullLoad(false);
    } catch (error) {
      setLoad(false);
      setFullLoad(false);
      error?.response?.data
        ? errorHandler(error?.response?.data?.errors, "Error")
        : errorHandler(
            "Network error: Something went wrong, Please check your internet connection and try again.",
            "Error",
          );
    }
  };

  const handleShortlist = async (id) => {
    try {
      setShortlistLoading(id);
      const res = await clientAddShortlistTalent(id);
      if (res?.data?.success) {
        toastSuccess("Talent added to shortlist");
      }

      setShortlistLoading(false);
    } catch (error) {
      setShortlistLoading(false);
      if (isPlanLimitError(error)) return planLimitHandler(error, navigate);
      error?.response?.data
        ? errorHandler(error?.response?.data?.errors, "Error")
        : errorHandler(
            "Network error: Something went wrong, Please check your internet connection and try again.",
            "Error",
          );
    }
  };
  const handleRemoveShortlist = async (id) => {
    try {
      setShortlistLoading(id);
      const res = await clientRemoveShortlistTalent(id);
      if (res?.data?.success) {
        toastSuccess("Talent removed from shortlist");
        if (isShortlist) {
          fetchAllShortlisted(page);
        } else {
          fetchAllJobs(page);
        }
      }
    } catch (error) {
      error?.response?.data
        ? errorHandler(error?.response?.data?.errors, "Error")
        : errorHandler(
            "Network error: Something went wrong, Please check your internet connection and try again.",
            "Error",
          );
    } finally {
      setShortlistLoading(false);
    }
  };

  useEffect(() => {
    if (!isShortlist) {
      fetchAllJobs();
    }
  }, [refine]);

  useEffect(() => {
    setFullLoad(true);
    fetchAllShortlisted();
  }, []);

  const activeFilterCount = () => {
    let count = 0;

    if (filters?.role?.trim()) count++;
    if (filters?.skills?.trim()) count++;
    if (filters?.location?.trim()) count++;
    if (filters?.paymentMin) count++;
    if (filters?.paymentMax) count++;
    if (filters?.jobTypes?.trim()) count++;
    if (filters?.workModes?.trim()) count++;

    return count;
  };

  const hasFilters = activeFilterCount() > 0;

  const handleResetFilters = () => {
    setFilters({
      role: "",
      skills: "",
      location: "",
      paymentMin: "",
      paymentMax: "",
      jobTypes: null,
      workModes: null,
    });
    fetchAllJobs();
  };


  useEffect(() => {
    if (!searchQuery) return;

    setFilters((prev) => ({
      ...prev,
      role: searchQuery,
    }));

    fetchAllJobs(1, {
      role: searchQuery,
    });
  }, [searchQuery]);

  return (
    <>
      <div className={classes.rowWrapper}>
        {fullLoad && <FullScreenLoader />}

        {isShortlist ? (
          <>
            {allShortlistArr?.map((item, i) => (
              <TalentRow
                key={item?.talent?._id}
                role={item?.talent?.pryRole}
                location={item?.talent?.currentLocation}
                workMode={item?.talent?.workMode}
                lowestCompensation={
                  item?.talent?.desiredCompensation?.lowestAmount
                }
                highestCompensation={
                  item?.talent?.desiredCompensation?.highestAmount
                }
                handleShortlist={handleShortlist}
                load={shortlistLoading === item?.talent?._id}
                id={item?.talent?._id}
                isShortlist
                isShortlisted={true}
                handleRemoveShortlist={handleRemoveShortlist}
                starredIds={starredIds}
                setStarredIds={setStarredIds}
              />
            ))}

            {allShortlistArr?.length === 0 && (
              <EmptyState
                icon={IconBookmark}
                title="No shortlisted talents yet"
                message="Tap the star icon on any talent in your Feed to save them here for later."
                showReset={false}
              />
            )}
          </>
        ) : (
          <>
            {allJobsArr?.map((item, i) => (
              <TalentRow
                key={item?.id}
                {...item}
                handleShortlist={handleShortlist}
                load={shortlistLoading === item.id}
                starredIds={starredIds}
                setStarredIds={setStarredIds}
                handleRemoveShortlist={handleRemoveShortlist}
                talent={item}
              />
            ))}

            {allJobsArr?.length === 0 && (
              <EmptyState
                icon={IconSearchOff}
                title="No talents found"
                message="No talents match your current filters. Try adjusting or clearing them."
                showReset={hasFilters}
                onReset={handleResetFilters}
              />
            )}
          </>
        )}

        {load && <img src={Loop2} alt="loader" type="loader" />}

        <SearchModal
          open={isSearchModalOpen}
          setModalOpen={setIsSearchModalOpen}
          filters={filters}
          setFilters={setFilters}
          handleSearchFilters={fetchAllJobs}
          committedFilters={filters}
          refine={refine}
          resultCount={allAllJobsData?.count}
        />
      </div>
      {allAllJobsData?.total > 0 && !isShortlist && (
        <Pagination
          pageSize={10}
          onChange={(e) => {
            setPage(e);
            fetchAllJobs(e);
          }}
          current={allAllJobsData?.page}
          total={allAllJobsData?.total}
          nextIcon={<IconChevronRight size={16} />}
          prevIcon={<IconChevronLeft size={16} />}
          showTitle={false}
        />
      )}

      {allShortlistData?.totalItems > 0 && isShortlist && (
        <Pagination
          pageSize={10}
          onChange={(e) => {
            setPage(e);
            fetchAllShortlisted(e);
          }}
          current={allShortlistData?.currentPage}
          total={allShortlistData?.totalItems}
          nextIcon={<IconChevronRight size={16} />}
          prevIcon={<IconChevronLeft size={16} />}
          showTitle={false}
        />
      )}
    </>
  );
};

export default ClientFeed;
